import { Component, ChangeDetectionStrategy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { first, Observable } from "rxjs";

import {
    Protocol,
    OccasionOccasionEntry,
} from "../../services/consultation.service";
import { stateBuilder } from "../../store/utils";
import { RootState } from "../../store/root";
import { ValidityMap, Validity } from "../../store/validity/state";
import { PersistenceService } from "../../store/model/persistence.service";
import { UtilsComponent } from "../../components/utils.component";
import { createEventOccasionEntry } from "../../data/model-utils";
import { eventOccasionOptions } from "./event-occasion.constants";

@Component({
    selector: "zbd-occasion-occasion",
    templateUrl: "event-occasion.component.html",
    styleUrls: ["./event-occasion.component.css"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventOccasionComponent extends UtilsComponent implements OnInit {
    state$: Observable<LocalState>;
    validity$: Observable<ValidityMap<Validity>>;

    eventOccasionOptions = eventOccasionOptions;

    constructor(
        public persistence: PersistenceService,
        store: Store<RootState>,
    ) {
        super();
        this.state$ = LocalState.create(store);
        this.validity$ = store.select<ValidityMap<Validity>>(
            (s) => s.validity.occasion.eventEntries,
        );
    }

    ngOnInit() {
        super.ngOnInit();

        setTimeout(() => {
            this.register(
                this.state$.pipe(first()).subscribe((state) => {
                    const allEntries = state.protocol.OccasionOccasionEntries;
                    const missingEntries = [];
                    eventOccasionOptions.forEach((option) => {
                        if (
                            allEntries.filter((e) => e.OccasionName === option)
                                .length === 0
                        ) {
                            missingEntries.push(
                                createEventOccasionEntry(false, option),
                            );
                        }
                    });
                    if (missingEntries.length > 0) {
                        this.persistence.addOccasionEntries(missingEntries);
                    }
                }),
            );
        }, 500);
    }

    addEntry(protocol: Protocol) {
        return () => {
            this.persistence.addProtocol_OccasionOccasionEntries(
                protocol,
                createEventOccasionEntry(true, null),
            );
        };
    }

    deleteEntry() {
        return (entry: OccasionOccasionEntry) => {
            if (entry.ManuallyAdded) {
                this.persistence.deleteOccasionOccasionEntry(entry);
            }
        };
    }

    isRemovableEntry() {
        return (item: OccasionOccasionEntry) => item.ManuallyAdded;
    }

    makeId(group: string, id: number) {
        return `${id}-${group}`;
    }
}

class LocalState {
    protocol: Protocol;

    static create(store: Store<RootState>): Observable<LocalState> {
        return stateBuilder(store, new LocalState()).apply(
            "protocol",
            (s) => s.model.ConsultationProcess.Protocol,
        ).state$;
    }
}
